module.exports = __webpack_public_path__ + "img/backgroundscenic_Image.35953629.png";